import React, { useRef, useEffect, useState, useMemo } from "react";
import axios from "axios";
import { HeaderAsociacion } from "../componentes/headerAsociacion";
import { HeroAsociacion } from "../componentes/heroAsociacion";
import { SponsorsAsociacion } from "../componentes/sponsorsAsociacion";
import { BandaAsociacion } from "../componentes/bandaAsociacion";
import { PilotosAsociacion } from "../componentes/pilotosAsociacion";
import { CalendarioAsociacion } from "../componentes/calendarioAsociacion";
import { ReglamentosAsociacion } from "../componentes/reglamentosAsociacion";
import { NavbarCategoriasAsociacion } from "../componentes/navbarCategoriasAsociacion";
import { NavbarSeccionesAsociacion } from "../componentes/navbarSeccionesAsociacion";
import { CardComponent } from "../componentes/cardComponent";
import { ListaReglamento } from "../componentes/listaReglamento";
import withReactContent from "sweetalert2-react-content";
import { manejarError } from "../manejo_errores";
import { CalendarioCard } from "../componentes/calendarioCard";
import { TablaCompleta } from "../tablas/tabla_simple";
import { Tabs, Row, Col, Form, Tooltip, Button, Modal, Checkbox, Table } from "antd";
import Swal from "sweetalert2";
import { FaDownload } from "react-icons/fa";
import { CustomFooter } from "../componentes/footer";
import { useParams, useNavigate, useSearchParams, Link } from "react-router-dom";
import pordefecto from "../pordefecto.png";
import pordefectopiloto from "../pordefectopiloto.png";
import { SelectCustom } from "../componentes/selectComponent";
import { SelectCustomResultados } from "../componentes/selectComponentResultados";
import moment from "moment";
import { HeadersAuth } from "../funciones_utiles";
import { TeamOutlined, UsergroupAddOutlined, UsergroupDeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { FranjaFija } from "../componentes/franjaFija";

export const HomeAsociacion = ({ setAlerta }) => {
  const manejarAlertas = (tipo,mensaje ) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const MySwal = withReactContent(Swal);
  const { siglas } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [idAsociacion, setIdAsociacion] = useState(null);
  const [asociacion, setAsociacion] = useState({});
  const [categoriasAgrupadas, setCategoriasAgrupadas] = useState(null);
  const [nav, setNav] = useState([]);
  const [categoriaActiva, setCategoriaActiva] = useState(null);
  const [campeonatoSeleccionado, setCampeonatoSeleccionado] = useState(null);
  const [imagen, setImagenes] = useState([]);
  const [campeonatosFiltrados, setCampeonatosFiltrados] = useState([]);
  const [activarTab, setActivarTab] = useState(null);
  const [resultadoSeleccionado, setResultadoSeleccionado] = useState("");
  const [pilotosPorFiltro, setPilotosPorFiltro] = useState([]);
  const [carrerasPorFiltro, setCarrerasPorFiltro] = useState([]);
  const [visible, setVisible] = useState(false);
  const [carreraSeleccionada, setCarreraSeleccionada] = useState(null);
  const [resultadosModal, setResultadosModal] = useState([]);
  const [detalleCeldaVisible, setDetalleCeldaVisible] = useState(false);
  const [detalleCeldaSeleccionada, setDetalleCeldaSeleccionada] = useState(null);
  const [pilotoPuntos, setPilotoPuntos] = useState(null); // piloto elegido en la tabla de resultados (ventana con sus puntos por fecha)
  const [publicidades, setPublicidades] = useState([]);
  const [imagenesFondo, setImagenesFondo] = useState([]);
  const [nombreAsoc, setNombreAsoc] = useState([]);
  const [instagram, setInstagram] = useState("");
  const [facebook, setFacebook] = useState("");

  useEffect(() => {
    const categoriaParam = searchParams.get("categoria");
    const categoriaIdInicial =
      categoriaParam && !isNaN(Number(categoriaParam)) ? Number(categoriaParam) : null;

    fetchAsociacion(categoriaIdInicial);
  }, [siglas]);

  const fetchAsociacion = async (categoriaObjetivoId = null) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/public/asociacion/${siglas}`
      );
      if (response.status === 200) {
        // console.log("response", response.data.publicidades)
        setPublicidades(response.data.publicidades)
        // console.log("response.data", response.data)

        // Extraer los datos de la respuesta
        const { id, nombre, logo, siglas, categoriasAgrupadas, instagram, facebook, imagenes } = response.data;
        setIdAsociacion(id);
        // console.log("id", id)
        setNombreAsoc(nombre);
        setInstagram(instagram);
        setFacebook(facebook);
        setImagenesFondo(imagenes);
        // Validar que los datos básicos existan
        if (!id || !nombre || !siglas) {
          console.error("Datos de la asociación incompletos:", response.data);
          return;
        }

        // Guardar la asociación y las categorías agrupadas
        setAsociacion({ id, nombre, logo, siglas });
        setCategoriasAgrupadas(categoriasAgrupadas || []);
        //console.log("cate", categoriasAgrupadas)
        setNav(
          categoriasAgrupadas.map((categoria) => ({
            key: categoria.id.toString(),
            label: categoria.categoria,
          }))
        );
        // console.log("CAtegoria Activa:",categoriasAgrupadas)

        const categoriaActiva = await fetchDatosCampeonato(categoriasAgrupadas, categoriaObjetivoId);
        const categoriaFiltrada = categoriaActiva
          ? categoriasAgrupadas.find(
              (categoria) => categoria.id === categoriaActiva
            )
          : null;
        // console.log("categoriaFiltrada", categoriaFiltrada)
        fetchDatosCategorias(categoriaFiltrada);

        if (categoriaFiltrada?.campeonatos?.length > 0) {
          const ultimoCampeonato = categoriaFiltrada.campeonatos.reduce(
            (prev, curr) => (prev.año > curr.año ? prev : curr) // Asumiendo que 'año' define el orden
          );

          fetchPilotoFiltrado(categoriaFiltrada, ultimoCampeonato.id);
          fetchCarrerasFiltradas(categoriaFiltrada, ultimoCampeonato.id);
        }
      }
    } catch (error) {
      console.error("Error al obtener los datos de la asociación:", error);
    }
  };

  //Obtener de la categoría por defecto (o la solicitada, si es válida) el último campeonato
  const fetchDatosCampeonato = async (categoriasAgrupadas, categoriaObjetivoId = null) => {
    // console.log("catgegorias Agrupadas",categoriasAgrupadas)
    try {
      if (categoriasAgrupadas.length > 0) {
        // Si viene una categoría solicitada (ej. desde el query param de la URL o un cambio de categoría)
        // y es válida para esta asociación, se usa esa; si no, se cae a la primera por defecto.
        const categoriaSolicitada = categoriaObjetivoId
          ? categoriasAgrupadas.find((categoria) => categoria.id === categoriaObjetivoId)
          : null;
        const categoriaDefault = categoriaSolicitada || categoriasAgrupadas[0];
        setActivarTab(categoriaDefault.id.toString());
        setCategoriaActiva(categoriaDefault.id);

        // Obtener el último campeonato de la categoría
        if (categoriaDefault.campeonatos?.length > 0) {
          const ultimoCampeonato = categoriaDefault.campeonatos.reduce(
            (prev, curr) => (prev.año > curr.año ? prev : curr) // Asumiendo que 'año' define el orden
          );
          setCampeonatoSeleccionado(ultimoCampeonato.id);
      // console.log("ult", ultimoCampeonato)

        }
        return categoriaDefault.id;
      }
    } catch (error) {
      console.error("Error al obtener los datos de la asociación:", error);
    }
  };

  const fetchDatosCategorias = async (categoriaFiltrada) => {
    try {
      if (categoriaFiltrada) {
        const campeonatos = categoriaFiltrada.campeonatos.map((campeonato) => ({
          id: campeonato.id,
          nombre_campeonato: campeonato.nombre_campeonato || "Sin nombre de campeonato",
          año: campeonato.año || 0,
          reglamento_general: campeonato.reglamento_general || "Sin reglamento general",
          reglamento: categoriaFiltrada.reglamento || "Sin reglamento de categorías",
          categoria: categoriaFiltrada.categoria || "Sin categoría",
          anexos: categoriaFiltrada.anexos || "Sin anexos",
          carreras: campeonato.carreras.map((carrera) => ({
            id: carrera.id,
            dia: carrera.dia || "Sin día de la carrera",
            dia_prueba: carrera.dia_prueba || "Sin día de la carrera de prueba",
            categoria_id: categoriaFiltrada.id,
            circuito: {
              nombre: carrera.circuito?.nombre || "Sin nombre del circuito",
              localidad:
                carrera.circuito?.localidad || "Sin circuito de la localidad",
              imagen: carrera.circuito?.imagen,
            },
            tieneInvitados: carrera.tieneInvitados,
            resultados: carrera.resultados
              ? Object.values(
                  carrera.resultados.reduce((acc, resultado) => {
                    acc[resultado.piloto_id] = {
                      ...acc[resultado.piloto_id],
                      ...resultado,
                      puntos: resultado.puntos != null ? resultado.puntos : "-",
                    };
                    return acc;
                  }, {})
                )
              : [],
            })),
        }));

        setCampeonatosFiltrados(campeonatos);
        //console.log("campeonatosdfdef", campeonatos)
      }
    } catch (error) {
      console.error("Error al obtener los datos de la asociación:", error);
    }
  };

  // Filtrar el campeonato seleccionado
  const fetchDatosFiltrados = () => {
    // Filtrar el campeonato seleccionado
    const campeonatoFiltrado = campeonatoSeleccionado
      ? campeonatosFiltrados.find(
          (campeonato) => campeonato.id === campeonatoSeleccionado
        )
      : null;
    //console.log("campeonatoFiltrado", campeonatoFiltrado)

    // Obtener las carreras del campeonato seleccionado (o todas si no hay selección)
    const carrerasFiltradas = campeonatoFiltrado
      ? campeonatoFiltrado.carreras
      : campeonatosFiltrados.flatMap((campeonato) => campeonato.carreras);
    //console.log("memo", carrerasFiltradas)
    // Datos para las cards de pilotos
    const filtroCampeonatoPilotos = campeonatoFiltrado
      ? {
          categoria: campeonatoFiltrado.categoria,
          resultados: resultadoFiltrado,
        }
      : [];

    return { campeonatoFiltrado, carrerasFiltradas, filtroCampeonatoPilotos };
  };

  // Calcular los resultados filtrados
  const resultadoFiltrado = useMemo(() => {
    if (!campeonatoSeleccionado || !campeonatosFiltrados.length) return [];

    const campeonatoFiltrado = campeonatosFiltrados.find(
      (campeonato) => campeonato.id === campeonatoSeleccionado
    );

    if (!campeonatoFiltrado || !campeonatoFiltrado.carreras) return [];

    // Si hay una carrera seleccionada, filtrar solo sus resultados
    if (resultadoSeleccionado) {
      const carreraEncontrada = campeonatoFiltrado.carreras.find(
        (carrera) => carrera.id === resultadoSeleccionado
      );
    
      return (carreraEncontrada?.resultados || []).sort((a, b) => a.posicion - b.posicion);
    }

    // Si no hay carrera seleccionada, mostrar todos los resultados del campeonato sin duplicar pilotos
    const resultadosUnicos = Object.values(
      campeonatoFiltrado.carreras
        .flatMap((carrera) => carrera.resultados)
        .reduce((acc, resultado) => {
          acc[resultado.piloto_id] = {
            ...acc[resultado.piloto_id],
            ...resultado,
            puntos: resultado.puntos != null ? resultado.puntos : 0,
          };
          return acc;
        }, {})
    );
    // console.log("resultados unicos", resultadosUnicos)
    // console.log("El sort",resultadosUnicos.sort((a, b) => b.posicion - a.posicion))

    return resultadosUnicos.sort((a, b) => b.puntos - a.puntos);

  }, [campeonatoSeleccionado, campeonatosFiltrados, resultadoSeleccionado]);

  // console.log("resultadoFiltrado", resultadoFiltrado)

  // Usamos useMemo para evitar recalculaciones innecesarias
  const { campeonatoFiltrado, carrerasFiltradas, filtroCampeonatoPilotos } =
    useMemo(
      () => fetchDatosFiltrados(),
      [campeonatoSeleccionado, campeonatosFiltrados, resultadoFiltrado]
    );

  //Manejo de la nav de categorías
  const handleCategoriaSelect = (key) => {
    const categoriaId = Number(key);

    // Reflejar la categoría elegida en la URL (persistencia para sobrevivir a un F5), sin ensuciar el historial de "atrás".
    // Se hace siempre, incluso en un click redundante, para que la URL nunca quede desactualizada.
    const nuevosParams = new URLSearchParams(searchParams);
    nuevosParams.set("categoria", String(categoriaId));
    setSearchParams(nuevosParams, { replace: true });

    // Si ya es la categoría activa (click redundante), no hay nada que recalcular: el efecto
    // que repuebla la tabla solo se dispara cuando categoriaActiva cambia de valor, así que
    // limpiar pilotosPorFiltro/columnasTabla acá dejaría la tabla vacía sin nada que la vuelva a llenar.
    if (categoriaId === categoriaActiva) {
      document.getElementById("inicio")?.scrollIntoView({ behavior: "smooth" });
      return;
    }

    setCategoriaActiva(categoriaId);
    setPilotosPorFiltro([]);
    setColumnasTabla([]);
    setResultadoSeleccionado("");

    document.getElementById("inicio")?.scrollIntoView({ behavior: "smooth" });
  };


  //manejo de select-campeonato
  const handleCampeonatoChange = (e) => {
    const nuevoCampeonatoId = Number(e.target.value);
    setCampeonatoSeleccionado(nuevoCampeonatoId);
    setResultadoSeleccionado("");
  };

  useEffect(() => {
    if (!categoriaActiva || !campeonatoSeleccionado || !categoriasAgrupadas?.length) return;

    const categoriaFiltrada = categoriasAgrupadas.find(
      (categoria) => categoria.id === categoriaActiva
    );

    if (!categoriaFiltrada) return;

    // (opcional) limpiar antes de pedir
    setPilotosPorFiltro([]);
    setColumnasTabla([]);

    // Recalcula campeonatosFiltrados (de donde derivan Pilotos, Calendario y Reglamentos)
    // para la nueva categoría; antes solo se calculaba al montar, dejando esas secciones
    // "pegadas" a la categoría anterior tras un click en la nav.
    fetchDatosCategorias(categoriaFiltrada);
    fetchPilotoFiltrado(categoriaFiltrada, campeonatoSeleccionado);
    fetchCarrerasFiltradas(categoriaFiltrada, campeonatoSeleccionado);

  }, [categoriaActiva, campeonatoSeleccionado, categoriasAgrupadas]);

  //console.log("invitados", carreraSeleccionada)
  //console.log("campoe", campeonatoSeleccionado)

  //manejo de select-fechas
  const handleFechaChange = (e) => {
    setResultadoSeleccionado(Number(e.target.value));
    document.getElementById("resultados")?.scrollIntoView({ behavior: "auto" });
  };

  // crear la lista de reglamentos
  const crearListaDeItems = (campeonatoFiltrado) => {
    if (!campeonatoFiltrado) return [];
    // console.log("3", campeonatoFiltrado)
    const { año, categoria, reglamento_general, reglamento, anexos } =
      campeonatoFiltrado;

    return [
      {
        id: "general",
        nombre: "Reglamento General",
        fecha: año,
        archivo: reglamento_general,
      },
      {
        id: "categoria",
        nombre: `Reglamento de Categoría (${categoria})`,
        fecha: año,
        archivo: reglamento,
      },
      ...(anexos && anexos.length > 0
        ? anexos.map((anexo, index) => ({
            id: `anexo-${index}`,
            nombre: `Anexo ${index + 1} (${categoria})`,
            fecha: año,
            archivo: anexo,
          }))
        : []),
    ];
  };
  const listaDeItems = crearListaDeItems(campeonatoFiltrado);

  const TituloInvitados = ({ carrera }) => {
    const esTelefono = useMediaQuery({ query: '(max-width: 768px)' });
    // console.log("care", carrera)
    return (
      <Button
        style={{
          fontSize: 16,
          backgroundColor: "#BA1721",
          color: "#fff",
          border: "none",
        }}
        onClick={() => abrirInvitados(carrera)}
      >
        {esTelefono ? <TeamOutlined title="Invitados"/> : "Invitados"}
      </Button>
    );
  };

  const abrirInvitados = (carrera) => {
    setCarreraSeleccionada(carrera); 
    setVisible(true)
  };

  const fetchPilotoFiltrado = async (categoriaFiltrada, campeonatoSeleccionado) => {
    try {
      if (categoriaFiltrada && campeonatoSeleccionado) {
        const campeonatoFiltrado = categoriaFiltrada.pilotosPorCampeonato.filter(
          (campeonato) => campeonato.campeonato_id === Number(campeonatoSeleccionado)
        );
        // //console.log("campeonatoFiltrado", campeonatoFiltrado)
        const carrerasFiltradas =
          categoriaFiltrada.campeonatos.find(
            (campeonato) => campeonato.id === Number(campeonatoSeleccionado)
          )?.carreras || [];

        // console.log("carrerasFiltradas", carrerasFiltradas)

        const carrerasInvitados = carrerasFiltradas.map(m => m).filter(t => t.tieneInvitados === true);

        if (carrerasInvitados.length > 0) {
          const pilotosFiltrados = carrerasFiltradas.map((carrera) => {
            // Ordenar todos por puntos descendente
            const resultadosOrdenados = [...carrera.resultados].sort((a, b) => b.puntos - a.puntos);
            //console.log("resultados con orden", resultadosOrdenados)
            // Asignar orden (posición) a todos, incluso con 0 puntos
            const resultadosConOrden = resultadosOrdenados.map((pil, index) => ({
              piloto_nombre: pil.piloto_nombre,
              piloto_apellido: pil.piloto_apellido,
              puntos: pil.puntos ?? "-",
              numero_piloto: pil.numero_piloto ?? "-",
              orden: index + 1,
              invitado: pil.pilotoInvitado_nombre ? `${pil.pilotoInvitado_nombre} ${pil.pilotoInvitado_apellido}` : "Sin invitado",
            }));

            // Eliminar duplicados por piloto
            const unicosPorPiloto = resultadosConOrden.filter(
              (piloto, index, self) =>
                index === self.findIndex((p) =>
                  p.piloto_nombre === piloto.piloto_nombre &&
                  p.piloto_apellido === piloto.piloto_apellido &&
                  p.numero_piloto === piloto.numero_piloto
                )
            );
            //console.log("result", resultadosConOrden)
            return {
              dia: carrera.dia,
              id: carrera.id,
              resultados: unicosPorPiloto,
              tieneInvitados: carrera.tieneInvitados
            };
          });

          setCarrerasPorFiltro(pilotosFiltrados);
        }

        if (campeonatoFiltrado.length > 0) {
          const pilotosFiltrados = campeonatoFiltrado.flatMap((campeonato) =>
            campeonato.pilotos.map((pil) => ({
              id: pil.id,
              nombre: pil.nombre,
              apellido: pil.apellido,
              puntos_totales: pil.puntos_totales ?? "-",
              numero_piloto: pil.numero_piloto ?? "-",
              mejor_posicion: pil.mejor_posicion ?? null,
            }))
          );
          //console.log("puntos", pilotosFiltrados)
  
          const toNumberOrNull = (v) => {
            if (typeof v === "number") return v;
            if (typeof v === "string") {
              const n = Number(v);
              return Number.isFinite(n) ? n : null;
            }
            return null;
          };

          const puntosNumericos = pilotosFiltrados
            .map((p) => toNumberOrNull(p.puntos_totales))
            .filter((n) => n != null);

          // si existe al menos un piloto con puntos > 0, ordeno por puntos
          const hayPuntos = puntosNumericos.some((n) => n > 0);

          const ordenados = [...pilotosFiltrados].sort((a, b) => {
            const pa = toNumberOrNull(a.puntos_totales) ?? 0;
            const pb = toNumberOrNull(b.puntos_totales) ?? 0;

            const posA = a.mejor_posicion;
            const posB = b.mejor_posicion;

            const na = a.numero_piloto !== "-" ? Number(a.numero_piloto) : Infinity;
            const nb = b.numero_piloto !== "-" ? Number(b.numero_piloto) : Infinity;

            if (hayPuntos) {
              if (pb !== pa) return pb - pa;

              if (posA != null && posB != null && posA !== posB) {
                return posA - posB;
              }

              if (posA != null && posB == null) return -1;
              if (posA == null && posB != null) return 1;

              return na - nb;
            }

            if (posA != null && posB != null && posA !== posB) {
              return posA - posB;
            }

            if (posA != null && posB == null) return -1;
            if (posA == null && posB != null) return 1;

            if (na !== nb) return na - nb;

            const aa = `${a.apellido} ${a.nombre}`.toLowerCase();
            const bb = `${b.apellido} ${b.nombre}`.toLowerCase();
            return aa.localeCompare(bb);
          });

          // asignar POS según el orden aplicado
          ordenados.forEach((piloto, index) => {
            piloto.orden = index + 1;
          });

          // console.log("sadsad", ordenados)
          
          const pilotosCarreras = carrerasFiltradas.flatMap((carrera) =>
            carrera.resultados.map((pil) => ({
              dia: carrera.dia,
              piloto_nombre: pil.piloto_nombre,
              piloto_apellido: pil.piloto_apellido,
              puntos: pil.puntos ?? 0,  // Asegurarnos de asignar 0 si los puntos son nulos
              puntosDetalle: pil.puntosDetalle && pil.puntosDetalle.length > 0 ? pil.puntosDetalle : null,
            }))
          );
          const fechasUnicas = [
            ...new Set(
              carrerasFiltradas.map((car) => car.dia)
            ),
          ].sort((a, b) => new Date(b) - new Date(a)); // Aseguramos que las fechas se ordenen cronológicamente

          // Filtrar fechas donde al menos un piloto tiene puntos > 0
          const fechasConPuntos = fechasUnicas.filter((fecha) =>
            pilotosCarreras.some(
              (pil) => pil.dia === fecha && pil.puntos > 0
            )
          );

          const pilotosMap = new Map();
          
          // Inicializar pilotos con campos fechaX vacíos
          ordenados.forEach((piloto) => {
            const key = `${piloto.nombre} ${piloto.apellido}`; // Combinar nombre y apellido para una clave única
            const pilotoData = {
              ...piloto,
            };
          
            // Crear un campo para cada fecha
            fechasConPuntos.forEach((_, i) => {
              pilotoData[`fecha${i + 1}`] = "-";
              pilotoData[`fecha${i + 1}_detalle`] = null;
            });
            
            pilotosMap.set(key, pilotoData);
          });
          fechasUnicas.sort((a, b) => new Date(a) - new Date(b));
          // console.log("Fechas ordenadas:", fechasUnicas);

          // Asignar los puntos a las fechas correspondientes
          pilotosCarreras.forEach((pil) => {
            const key = `${pil.piloto_nombre} ${pil.piloto_apellido}`;  // Clave única para cada piloto
            const piloto = pilotosMap.get(key);
            
            if (piloto) {
              const indexFecha = fechasConPuntos.indexOf(pil.dia);
              if (indexFecha !== -1) {
                piloto[`fecha${indexFecha + 1}`] = pil.puntos;  // Asignar puntos
                piloto[`fecha${indexFecha + 1}_detalle`] = pil.puntosDetalle;  // Desglose de esa carrera puntual
              }
            }

          });
          // Puntos de cada piloto por fecha: ya no son columnas de la tabla, se ven en una ventana al hacer click en el piloto
          pilotosMap.forEach((piloto) => {
            piloto.puntosPorFecha = [...fechasConPuntos]
              .reverse()
              .map((fecha) => {
                const i = fechasConPuntos.indexOf(fecha);
                return {
                  fecha,
                  puntos: piloto[`fecha${i + 1}`],
                  detalle: piloto[`fecha${i + 1}_detalle`],
                  idCarrera: carrerasFiltradas.find((c) => c.dia === fecha)?.id,
                  carreraConInvitados: carrerasInvitados.find((c) => c.dia === fecha) || null,
                };
              });
          });

          // Actualizar las columnas de la tabla
          const columnasSinPuntosTotales = columnaDefault.filter(
            (col) => col.dataIndex !== "puntos_totales"
          );
          
          const columnaPuntosTotales = columnaDefault.find(
            (col) => col.dataIndex === "puntos_totales"
          );
          
          setColumnasTabla([
            ...columnasSinPuntosTotales,
            columnaPuntosTotales,
          ]);

          // Asignar los pilotos procesados a la tabla
          const resultadoFinal = Array.from(pilotosMap.values());
          //console.log("log", resultadoFinal)
          setPilotosPorFiltro(resultadoFinal);
          
        } else {
          setPilotosPorFiltro([]);
        }
      }
    } catch (error) {
      console.error("Error al obtener los datos del piloto:", error);
    }
  };

  const fetchCarrerasFiltradas = async (categoriaFiltrada, campeonatoSeleccionado) => {
    try {
      if (categoriaFiltrada && campeonatoSeleccionado) {
        //console.log("categorisdsadasdasdasd", categoriaFiltrada)
        const campeonatoFiltrado = categoriaFiltrada.pilotosPorCampeonato.filter(
          (campeonato) => campeonato.campeonato_id === campeonatoSeleccionado
        );

        const carrerasFiltradas =
          categoriaFiltrada.campeonatos.find(
            (campeonato) => campeonato.id === campeonatoSeleccionado
          )?.carreras || [];
        //console.log("carre", carrerasFiltradas)
        if (campeonatoFiltrado.length > 0) {
          const pilotosFiltrados = carrerasFiltradas.map((carrera) => {
            // Ordenar todos por puntos descendente
            const resultadosOrdenados = [...carrera.resultados].sort((a, b) => b.puntos - a.puntos);
            //console.log("resultados con orden", resultadosOrdenados)
            // Asignar orden (posición) a todos, incluso con 0 puntos
            const resultadosConOrden = resultadosOrdenados.map((pil, index) => ({
              piloto_nombre: pil.piloto_nombre,
              piloto_apellido: pil.piloto_apellido,
              puntos: pil.puntos ?? "-",
              numero_piloto: pil.numero_piloto ?? "-",
              orden: index + 1,
              invitado: pil.pilotoInvitado_nombre ? `${pil.pilotoInvitado_nombre} ${pil.pilotoInvitado_apellido}` : "Sin invitado",
            }));

            // Eliminar duplicados por piloto
            const unicosPorPiloto = resultadosConOrden.filter(
              (piloto, index, self) =>
                index === self.findIndex((p) =>
                  p.piloto_nombre === piloto.piloto_nombre &&
                  p.piloto_apellido === piloto.piloto_apellido &&
                  p.numero_piloto === piloto.numero_piloto
                )
            );
            //console.log("result", resultadosConOrden)
            return {
              dia: carrera.dia,
              id: carrera.id,
              resultados: unicosPorPiloto,
              tieneInvitados: carrera.tieneInvitados
            };
          });

          setCarrerasPorFiltro(pilotosFiltrados);
          // console.log("pilotosFiltrados", pilotosFiltrados)
        }
      }
    } catch (error) {
      console.error("Error al obtener los datos de la carrera:", error);
    }
  };
  // Columnas de resultados por default
  const columnaDefault = [
    //Por si en un futuro se requiere
    {
      title: "POS.",
      dataIndex: "orden",
      key: "orden",
      align: "center",
      width: "70px",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.orden - b.orden,
      render: (text) => (
        <div style={{ fontSize: "14px", padding: "2px 4px" }}>
          {text != null ? String(text) : "-"}
        </div>
      ),
    },
    {
      title: "NRO.",
      dataIndex: "numero_piloto",
      key: "numero_piloto",
      align: "center",
      width: "70px",
      sorter: (a, b) => {
        const NumA = a.numero_piloto !== "-" ? Number(a.numero_piloto) : -Infinity;
        const NumB = b.numero_piloto !== "-" ? Number(b.numero_piloto) : -Infinity;
        return NumA.localeCompare(NumB);
      },
      render: (text) => (
        <div style={{ fontSize: "14px", padding: "2px 4px" }}>
          {text != null ? String(text) : "-"}
        </div>
      ),
    },
    {
      title: "PILOTO",
      key: "nombre",
      align: "left",
      sorter: (a, b) => {
        const nombreA = `${a.apellido} ${a.nombre || ""}`.trim();
        const nombreB = `${b.apellido} ${b.nombre || ""}`.trim();
        return nombreA.localeCompare(nombreB);
      },
      render: (a) => (
        <div style={{ fontSize: "14px", padding: "2px 4px" }}>
          {a.apellido}, {a.nombre}
        </div>
      ),
    },
    {
      title: "PUNTOS TOTALES",
      key: "puntos_totales",
      dataIndex: "puntos_totales", // ← esto es clave para que defaultSortOrder funcione
      align: "center",
      defaultSortOrder: "ascend", // también podés usar "ascend"
      width: "230px",
      sorter: (a, b) => {
        const puntosA =
          typeof a.puntos_totales === "number" ? a.puntos_totales : -Infinity;
        const puntosB =
          typeof b.puntos_totales === "number" ? b.puntos_totales : -Infinity;
        return puntosB - puntosA;
      },
      render: (text) => (
        <div style={{ fontSize: "14px", padding: "2px 4px" }}>
          {text != null ? String(text) : "-"}
        </div>
      ),
    },
  ];

  const getColumnasModal = (esCarreraConInvitado) => {
    const columnas = [
      {
        title: "POS.",
        dataIndex: "orden",
        key: "orden",
        align: "center",
        width: "70px",
        defaultSortOrder: "ascend",
        sorter: (a, b) => a.orden - b.orden,
        render: (text) => (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {text != null ? String(text) : "-"}
          </div>
        ),
      },
      {
        title: "NRO.",
        dataIndex: "numero_piloto",
        key: "numero_piloto",
        align: "center",
        width: "70px",
        sorter: (a, b) => a.numero_piloto - b.numero_piloto,
        render: (text) => (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {text != null ? String(text) : "-"}
          </div>
        ),
      },
      {
        title: "PILOTO",
        key: "nombre",
        align: "left",
        sorter: (a, b) => {
          const nombreA = `${a.piloto_nombre} ${a.piloto_apellido || ""}`.trim();
          const nombreB = `${b.piloto_nombre} ${b.piloto_apellido || ""}`.trim();
          return nombreA.localeCompare(nombreB);
        },
        render: (a) => (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {a.piloto_nombre} {a.piloto_apellido}
          </div>
        ),
      },
    ];

    // Si es carrera con invitado, agregamos la columna TITULAR
    if (esCarreraConInvitado) {
      columnas.push({
        title: "INVITADO",
        dataIndex: "invitado",
        key: "invitado",
        align: "left",
      });
    }

    // Continuamos con las demás columnas
    columnas.push(
      {
        title: "PUNTOS CARRERA",
        key: "puntos",
        dataIndex: "puntos",
        align: "center",
        defaultSortOrder: "ascend",
        width: "230px",
        sorter: (a, b) => {
          const puntosA = typeof a.puntos === "number" ? a.puntos : -Infinity;
          const puntosB = typeof b.puntos === "number" ? b.puntos : -Infinity;
          return puntosB - puntosA;
        },
        render: (text) => (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {text != null ? String(text) : "-"}
          </div>
        ),
      }
    );

    return columnas;
  };

  const mostrarModal = (carrera) => {
  setCarreraSeleccionada(carrera); // Guardamos cuál carrera fue seleccionada
  setVisible(true);
  };

  const cerrarModal = () => {
  setVisible(false);
  setCarreraSeleccionada(null);
  };

  const abrirDetalleCelda = ({ piloto, fecha, idCarrera, detalle }) => {
    setDetalleCeldaSeleccionada({
      piloto_nombre: piloto?.nombre,
      piloto_apellido: piloto?.apellido,
      fecha,
      idCarrera,
      detalle,
    });
    setDetalleCeldaVisible(true);
  };

  const cerrarDetalleCelda = () => {
    setDetalleCeldaVisible(false);
    setDetalleCeldaSeleccionada(null);
  };

  const resultadosFiltrados = carrerasPorFiltro
    .filter((resultado) =>
      carreraSeleccionada &&
      moment(resultado.dia).format("DD/MM/YYYY") === (moment(carreraSeleccionada.dia).format("DD/MM/YYYY"))
    )
    .flatMap((resultado) => resultado.resultados || []);

  // console.log("resultadosFiltrados", resultadosFiltrados)

  const columnaPorDefecto = [
    //Por si en un futuro se requiere
    ...columnaDefault
  ];

  const [columnasTabla, setColumnasTabla] = useState([]);
  const containerRef = useRef(null);
  const [repeatCount, setRepeatCount] = useState(1);
  const DURACION_TOTAL = 45; // segundos

  useEffect(() => {
    if (containerRef.current && publicidades.length > 0) {
      const contenedorVisible = containerRef.current.offsetWidth;
      const anchoContenido = containerRef.current.scrollWidth;

      // Asegurar que haya al menos dos veces el contenido visible para animación continua
      const repeticiones = Math.ceil((contenedorVisible * 2) / anchoContenido);
      setRepeatCount(repeticiones);
    }
  }, [publicidades]);

  // Pilotos registrados en la categoría y el campeonato seleccionados, sin repetir.
  // La API puede traer al mismo piloto más de una vez (a veces una sin número): se queda con la que tiene número.
  const categoriaActual = categoriasAgrupadas?.find((c) => c.id === categoriaActiva);
  const pilotosRegistrados = useMemo(() => {
    if (!categoriaActual || !campeonatoSeleccionado) return [];
    const porId = new Map();
    (categoriaActual.pilotosPorCampeonato || [])
      .filter((c) => c.campeonato_id === Number(campeonatoSeleccionado))
      .forEach((c) =>
        (c.pilotos || []).forEach((p) => {
          const previo = porId.get(p.id);
          if (!previo || (previo.numero_piloto == null && p.numero_piloto != null)) porId.set(p.id, p);
        })
      );
    return [...porId.values()].sort((a, b) => {
      const na = a.numero_piloto ?? Infinity;
      const nb = b.numero_piloto ?? Infinity;
      if (na !== nb) return na - nb;
      return `${a.apellido} ${a.nombre}`.localeCompare(`${b.apellido} ${b.nombre}`);
    });
  }, [categoriaActual, campeonatoSeleccionado]);
  // Mostrar los datos de la asociación
  return (
    <>
      <HeaderAsociacion />
      {/* La ruta de la bandera se pasa como variable CSS: las rutas de public/ no se pueden poner directo en App.css */}
      <section id="inicio" style={{ "--bandera-asoc": "url('/img/asoc-bandera-fondo.png')" }}>
        <HeroAsociacion nombre={nombreAsoc} imagenes={imagenesFondo} />
        <SponsorsAsociacion publicidades={publicidades} />
        <BandaAsociacion idAsociacion={asociacion.id} logo={asociacion.logo} nombre={nombreAsoc} />

        {/* Categorías: bajan con la página (como el logo) */}
        <div className="navbar-asoc">
          <NavbarCategoriasAsociacion
            categorias={nav}
            categoriaActiva={categoriaActiva}
            onSelect={handleCategoriaSelect}
          />
        </div>
        {/* Secciones y campeonato: esta es la única barra fija. Va fuera de navbar-asoc para que
            el sticky se mantenga en toda la página */}
        <NavbarSeccionesAsociacion
          campeonatos={campeonatosFiltrados}
          campeonatoSeleccionado={campeonatoSeleccionado}
          onCampeonatoChange={handleCampeonatoChange}
          logo={
            asociacion.id && asociacion.logo
              ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${asociacion.id}/IMAGENES/ASOCIACIONES/${asociacion.logo}`
              : null
          }
          nombre={nombreAsoc}
        />

        {/* Resultados */}
        <FranjaFija izq="#D9D9D9">
        <section className="resultados-asoc" id="resultados">
          {campeonatoSeleccionado && (
            <>
              <span className="resultados-asoc-barra" />
              <h2 className="resultados-asoc-titulo">Resultados</h2>

              {/* Tabla de Resultados por Fecha */}
              {pilotosPorFiltro.length > 0 ? (
                <TablaCompleta
                  tituloPDF="Resultados Anuales"
                  columns={columnasTabla}
                  fetchDatos={pilotosPorFiltro}
                  rowKey="id"
                  filtrarUltimaColumna={false}
                  filasPorPagina={10}
                  mostrarBoton={false}
                  claseRaiz="tabla-resultados-asoc"
                  mostrarSelectorFilas
                  onFilaClick={(piloto) => setPilotoPuntos(piloto)}
                />
              ) : (
                <p className="resultados-asoc-vacio">No hay resultados disponibles</p>
              )}

              {/* Ventana con los puntos de un piloto en cada fecha */}
              <Modal
                title={pilotoPuntos ? `${pilotoPuntos.apellido || ""}, ${pilotoPuntos.nombre || ""}` : "Puntos del piloto"}
                open={!!pilotoPuntos}
                onCancel={() => setPilotoPuntos(null)}
                footer={[
                  <Button className="buttonModal" key="cerrar" onClick={() => setPilotoPuntos(null)}>
                    Cerrar
                  </Button>,
                ]}
                width={460}
              >
                {pilotoPuntos && (
                  <>
                    <p style={{ margin: "0 0 12px" }}>
                      Puntos totales: <strong>{pilotoPuntos.puntos_totales ?? "-"}</strong>
                    </p>
                    <Table
                      dataSource={pilotoPuntos.puntosPorFecha || []}
                      rowKey="fecha"
                      pagination={false}
                      size="small"
                      locale={{ emptyText: "Todavía no hay puntos cargados por fecha" }}
                      columns={[
                        {
                          title: "FECHA",
                          dataIndex: "fecha",
                          key: "fecha",
                          render: (fecha) =>
                            new Date(fecha).toLocaleDateString("es-AR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            }),
                        },
                        {
                          title: "PUNTOS",
                          key: "puntos",
                          align: "center",
                          render: (fila) => {
                            const tieneDetalle = Array.isArray(fila.detalle) && fila.detalle.length > 0;
                            return (
                              <span>
                                {fila.puntos !== "-" && fila.puntos != null ? String(fila.puntos) : "-"}{" "}
                                {tieneDetalle && (
                                  <InfoCircleOutlined
                                    title="Ver desglose de puntos"
                                    style={{ color: "#1677ff", cursor: "pointer" }}
                                    onClick={() =>
                                      abrirDetalleCelda({
                                        piloto: pilotoPuntos,
                                        fecha: fila.fecha,
                                        idCarrera: fila.idCarrera,
                                        detalle: fila.detalle,
                                      })
                                    }
                                  />
                                )}
                              </span>
                            );
                          },
                        },
                        {
                          title: "",
                          key: "invitados",
                          align: "center",
                          render: (fila) =>
                            fila.carreraConInvitados ? <TituloInvitados carrera={fila.carreraConInvitados} /> : null,
                        },
                      ]}
                    />
                  </>
                )}
              </Modal>
              {/* Modal de desglose de puntos de una celda piloto+carrera */}
              <Modal
                title={
                  detalleCeldaSeleccionada
                    ? `${detalleCeldaSeleccionada.piloto_apellido || ""}, ${detalleCeldaSeleccionada.piloto_nombre || ""} - ${new Date(
                        detalleCeldaSeleccionada.fecha
                      ).toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" })}`
                    : "Desglose de puntos"
                }
                open={detalleCeldaVisible}
                onCancel={cerrarDetalleCelda}
                footer={[
                  <Button className="buttonModal" key="cerrar" onClick={cerrarDetalleCelda}>
                    Cerrar
                  </Button>,
                ]}
                width={400}
              >
                <Table
                  dataSource={detalleCeldaSeleccionada?.detalle || []}
                  rowKey="id"
                  pagination={false}
                  size="small"
                  columns={[
                    {
                      title: "TIPO",
                      key: "tipo",
                      render: (record) => record.tipoLabel || record.tipo,
                    },
                    { title: "PUNTOS", dataIndex: "puntos", key: "puntos", align: "center" },
                  ]}
                />
              </Modal>
            </>
          )}
        </section>
        </FranjaFija>

        <SponsorsAsociacion publicidades={publicidades} entre />
        {/* Pilotos */}
        {campeonatoSeleccionado ? (
          <PilotosAsociacion
            pilotos={pilotosRegistrados}
            categoria={categoriaActual?.categoria}
            idAsociacion={idAsociacion}
          />
        ) : (
          <section id="pilotos" />
        )}
        <SponsorsAsociacion publicidades={publicidades} entre />
        {/* Fechas */}
        {campeonatoSeleccionado ? (
          <CalendarioAsociacion
            carreras={carrerasFiltradas}
            categoria={categoriaActual?.categoria}
            campeonato={campeonatoFiltrado?.nombre_campeonato}
            idAsociacion={idAsociacion}
            claveReinicio={`${categoriaActiva}-${campeonatoSeleccionado}`}
            tieneResultados={(carrera) =>
              (carrerasPorFiltro.find((c) => c.id === carrera.id)?.resultados || []).some((p) => Number(p.puntos) > 0)
            }
            onVerResultados={mostrarModal}
          />
        ) : (
          <section id="calendarios" />
        )}

        {/* Resultados de una carrera puntual (se abre desde el calendario) */}
        <Modal
          title="Resultados de la carrera"
          open={visible}
          onCancel={cerrarModal}
          footer={[
            <Button className="buttonModal" key="cerrar" onClick={cerrarModal}>
              Cerrar
            </Button>,
          ]}
          width={800}
        >
          <TablaCompleta
            columns={getColumnasModal(carreraSeleccionada?.tieneInvitados)}
            fetchDatos={resultadosFiltrados}
            rowKey={(record) =>
              `${record.numero_piloto || "sin-numero"}-${record.piloto_nombre.trim()}-${record.piloto_apellido.trim()}`
            }
            filtrarUltimaColumna={false}
            filasPorPagina={30}
            mostrarBoton={false}
            mostrarBuscador={false}
          />
        </Modal>
        <SponsorsAsociacion publicidades={publicidades} entre />
        {/* Reglamentos */}
        {campeonatoSeleccionado ? (
          <ReglamentosAsociacion
            items={campeonatoFiltrado ? listaDeItems : []}
            campeonato={campeonatoFiltrado?.nombre_campeonato}
            idAsociacion={idAsociacion}
          />
        ) : (
          <section id="reglamentos" />
        )}
        <SponsorsAsociacion publicidades={publicidades} entre />
      </section>

      <CustomFooter mostrarInstagram={false} />
    </>
  );
};
